import React from 'react';
import DashboardLayout from '../../components/Layout/DashboardLayout';
import NotificationList from '../../components/ui/NotificationList';
import { useAuth } from '../../contexts/AuthContext';
import { useNotificationContext } from '../../contexts/NotificationContext';

const NotificationSupplierScreen = () => {
    const { isLoading: authLoading } = useAuth();
    const {
        notifications,
        loading,
        error,
        markAllAsRead,
        deleteAllNotifications,
        deleteNotification,
        markAsRead,
    } = useNotificationContext();

    return (
        <DashboardLayout activeMenuItem="Notificaciones" isScrollable={true}>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3">
                <h1 className="h2 mb-4">Notificaciones</h1>
                <div className="btn-toolbar mb-2 mb-md-0">
                    <div className="btn-group me-2">
                        <button
                            type="button"
                            className="btn btn-small btn-outline-secondary"
                            onClick={markAllAsRead}
                        >
                            <i className="bi bi-check-circle me-1"></i> Marcar todas como leídas
                        </button>
                        <button
                            type="button"
                            className="btn btn-small btn-outline-danger"
                            onClick={deleteAllNotifications}
                        >
                            <i className="bi bi-eraser-fill me-1"></i> Limpiar todas
                        </button>
                    </div>
                </div>
            </div>

            <div className="row text-start mb-4">
                <div className="col-12">
                    <div className="card card-metric border-0">
                        <div className="card-body px-md-2 px-0">
                            {loading || authLoading ? (
                                <p className="text-center text-muted">Cargando notificaciones...</p>
                            ) : error ? (
                                <p className="text-center text-danger">{error}</p>
                            ) : (
                                <NotificationList
                                    notifications={notifications}
                                    onMarkAsRead={markAsRead}
                                    onDelete={deleteNotification}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </DashboardLayout>
    );
};

export default NotificationSupplierScreen;